<div class="form-group row">
  @if (props.text) {
    <label
      [attr.for]="id"
      class="col-md-5 form-label d-flex align-items-center {{ labelIndentCssClass }}"
      [attr.role]="props.group ? 'presentation' : null"
      >
      <span [id]="id + key?.toString()" class="font-weight-bold">{{ props.text }}</span>
      @if (props.tooltip) {
        <span
          class="help-tooltip-icon ms-2"
          [ngbTooltip]="tooltipContent"
          tooltipClass="help-tooltip"
          triggers="{{ window.screen.width < 769 ? 'click' : 'hover' }}"
          role="tooltip"
        ></span>
      }
      <ng-template #tooltipContent>
        <div [innerHtml]="props.tooltip"></div>
      </ng-template>
    </label>
  }

  <div
    class="col-md-7 d-flex justify-content-center align-items-center"
    [attr.role]="props.group ? 'group' : null"
    [attr.aria-labelledby]="id + key?.toString()"
    [attr.aria-describedby]="props.tooltip ? (id + key?.toString() + '_desc') : null"
    >
    <ng-template #fieldComponent></ng-template>
    @if (props.tooltip) {
      <span id="id + key?.toString() + '_desc'" class="sr-only">{{props.tooltip}}</span>
    }
  </div>
</div>
